var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classes,attrs:{"type":_vm.type,"disabled":_vm.isLoading || _vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.isLoading)?_c('i',{staticClass:"material-icons align-middle spin-animation"},[_vm._v("refresh")]):_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }